import { useTranslation } from 'react-i18next'
import { isBefore } from 'date-fns'

import { AnonymousLearningItem } from '../../models/AnonymousLearningItem'

export default function learningItemInfoText(
  t: ReturnType<typeof useTranslation>['t'],
  learningItem: AnonymousLearningItem
) {
  if (learningItem.kind === 'onDemandCourse') {
    return `${t('format.{count} MINUTES', { count: learningItem.onDemandCourse.durationInMin })}`
  }

  if (learningItem.kind === 'scheduledCourse') {
    const now = new Date()
    const futureEvents = learningItem.scheduledCourse.events.filter((event) => isBefore(now, event.startDate))

    return t('learning item.<count> future events from <firstDate> to <lastDate>', {
      count: futureEvents.length,
      firstDate: futureEvents[0]?.startDate,
      lastDate: futureEvents[futureEvents.length - 1]?.startDate,
    })
  }

  return null
}
